module.exports = __webpack_public_path__ + "img/1546023293.922413c5.jpg";